import type { ComponentType } from 'react';
import { BrandCarousel } from '@/components/BrandCarousel';
import { ChartListTracker } from '@/components/ChartListTracker';
import { ChartProductList } from '@/components/ChartProductList';
import { ContentCarousel } from '@/components/ContentCarousel';
import { EditorialHeroProductRail } from '@/components/EditorialHeroProductRail';
import { HomePageHeroBanner } from '@/components/HomePageHeroBanner';
import { InterruptionTile } from '@/components/InterruptionTile';
import { MediaBlock } from '@/components/MediaBlock';
import { AddToBasketMount } from '@/components/CalloutAddToBasket';
import { ProductAddToBasketButton } from '@/components/ProductAddToBasketButton';
import { HeroBanner } from '@/components/HeroBanner';
import { ProductCarousel } from '@/components/ProductCarousel';
import { ReviewsCarouselBlock } from '@/components/ReviewsCarousel';
import { SitewideMessagingBanner } from '@/components/SitewideMessagingBanner';
import { SplitLayoutFeaturedKeyProduct } from '@/components/SplitLayoutFeaturedKeyProduct';
import { SplitLayoutFeaturedProductRail } from '@/components/SplitLayoutFeaturedProductRail';
import { StoreLocator } from '@/components/StoreLocator';
import { GiftCardAddToCart } from '@/components/GiftCardAddToCart';
import { SplitLayoutHeroPromo } from '@/components/SplitLayoutHeroPromo';

export const componentRegistry: Record<string, ComponentType<{ data: any }>> = {
    HeroBanner,
    ProductCarousel,
    ReviewsCarousel: ReviewsCarouselBlock,
    AddToBasketMount,
    ProductAddToBasketButton,
    SplitLayoutFeaturedProductRail,
    SplitLayoutFeaturedKeyProduct,
    SplitLayoutHeroPromo,
    SitewideMessagingBanner,
    MediaBlock,
    EditorialHeroProductRail,
    ChartProductList,
    ChartListTracker,
    InterruptionTile,
    StoreLocator,
    GiftCardAddToCart,
    BrandCarousel,
    ContentCarousel,
    HomePageHeroBanner,
};
